import { useLocale } from "@/hooks/useLocale";
import { Banner } from "@/ui/Banner";
import { DynamicText } from "@/ui/DynamicText";
import { DynamicHtml } from "@/ui/DynamicHtml";
import { Button, Col, Row } from "react-bootstrap";
import ArrowRight from "@/assets/ArrowRight.svg";
import { useLink } from "@/hooks/useLink";

export const HiringPageBannerSection = ({ className }) => {
  const locale = useLocale();
  const link = useLink();

  return (
    <Banner
      className={className}
      title={<DynamicText path={`page.hiring.banner.title.${locale}`} tag="h1" />}
      image={{ path: "page.hiring.banner.image", src: "/assets/banners/default.webp" }}
    >
      <Row>
        <Col xs={12} md={6}>
          <DynamicHtml path={`page.hiring.banner.text.${locale}`} className="pb-5 mb-5" />
          <Button href={link("submit-job")} variant="secondary">
            <DynamicText path={`page.hiring.banner.button.${locale}`} className="me-4" />
            <ArrowRight width="14" height="12" />
          </Button>
        </Col>
      </Row>
    </Banner>
  );
};
